import { StyleSheet, ViewStyle, TextStyle } from 'react-native';
import theme from '../../common/theme';

export const styles = StyleSheet.create({
  btn: {
    minWidth: 100,
    paddingHorizontal: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.grey1,
  },
  btnIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.radius.small,
  },
  btnText: {
    color: theme.colors.grey6,
    textTransform: 'uppercase',
  },
  textButton: {
    lineHeight: 28,
    textAlign: 'center',
    color: theme.colors.grey6,
    fontFamily: theme.fonts.medium,
  },
});

export const getContainerStyle = (
  type: string | undefined,
  isIcon?: boolean,
) => {
  const containerStyles: ViewStyle[] = isIcon ? [styles.btnIcon] : [styles.btn];

  switch (type) {
    case 'primary':
      containerStyles.push({ backgroundColor: theme.colors.primary });
      break;
    case 'primaryLight':
      containerStyles.push({ backgroundColor: theme.colors.primaryLight });
      break;
    case 'accent':
      containerStyles.push({ backgroundColor: theme.colors.secondary });
      break;
    case 'positive':
      containerStyles.push({ backgroundColor: theme.colors.states.positive });
      break;
    case 'negative':
      containerStyles.push({ backgroundColor: theme.colors.states.negative });
      break;
    case 'neutral':
      containerStyles.push({ backgroundColor: theme.colors.states.neutral });
      break;
    case 'focus':
      containerStyles.push({ backgroundColor: theme.colors.states.focus });
      break;
    case 'positiveLight':
      containerStyles.push({ backgroundColor: theme.colors.greenLight });
      break;
    case 'negativeLight':
      containerStyles.push({ backgroundColor: theme.colors.redLight });
      break;
    case 'neutralLight':
      containerStyles.push({ backgroundColor: theme.colors.blueLight });
      break;
    case 'focusLight':
      containerStyles.push({ backgroundColor: theme.colors.amberLight });
      break;
    case 'interface':
      containerStyles.push({ backgroundColor: theme.colors.teritiary2 });
      break;
    case 'disabledInterface':
      containerStyles.push({ backgroundColor: theme.colors.teritiary1 });
      break;
    case 'transparent':
      containerStyles.push({ backgroundColor: theme.colors.transparent });
      break;
    default:
      containerStyles.push({ backgroundColor: theme.colors.grey1 });
      break;
  }

  return containerStyles;
};

export const getLabelStyle = (
  type: string | undefined,
  uppercase?: boolean,
  height?: number,
) => {
  const labelStyles: TextStyle[] = [styles.textButton];

  if (uppercase) {
    labelStyles.push({ textTransform: 'uppercase' });

    if (height === 34) {
      labelStyles.push({ fontSize: 12 });
    }
  }

  if (type === 'primaryLight') {
    labelStyles.push({ color: theme.colors.primary });
  } else if (type === 'accentLight') {
    labelStyles.push({ color: theme.colors.secondary });
  } else if (type === 'positiveLight') {
    labelStyles.push({ color: theme.colors.states.positive });
  } else if (type === 'negativeLight') {
    labelStyles.push({ color: theme.colors.states.negative });
  } else if (type === 'neutralLight') {
    labelStyles.push({ color: theme.colors.states.neutral });
  } else if (type === 'focusLight') {
    labelStyles.push({ color: theme.colors.states.focus });
  } else if (type === 'disabled') {
    labelStyles.push({ color: theme.colors.grey5 });
  } else if (type === 'cancel') {
    labelStyles.push({ color: theme.colors.secondaryDark });
  } else if (type === 'teal') {
    labelStyles.push({ color: theme.colors.teal });
  } else {
    labelStyles.push({ color: theme.colors.white });
  }

  return labelStyles;
};

export const getIconColor = (type: string | undefined) => {
  switch (type) {
    case 'primary':
    case 'primaryLight':
    case 'accent':
    case 'positive':
    case 'negative':
    case 'neutral':
    case 'focus':
    case 'interface':
      return theme.colors.white;
    case 'positiveLight':
      return theme.colors.states.positive;
    case 'negativeLight':
      return theme.colors.states.negative;
    case 'neutralLight':
      return theme.colors.states.neutral;
    case 'focusLight':
      return theme.colors.states.focus;
    case 'cancel':
      return theme.colors.secondaryDark;
    case 'disabled':
      return theme.colors.grey4;
    case 'disabledInterface':
      return theme.colors.grey7;
    default:
      return theme.colors.grey6;
  }
};

export default {
  styles,
  getContainerStyle,
  getLabelStyle,
};
